<template>
  <div class="container">
    <pcTabBarComponent tabBarKey="user" />
    <pcUserNavComponent tabBarKey="balanceRecord">
      <div class="page-container">
        <div class="page-title-item">
          <div class="title-item active">收支明细</div>
        </div>
        <div class="type-list-item">
          <div class="type-item" :class="Type == 0 ? 'active' : ''" @click="Type = 0">全部</div>
          <div class="type-item" :class="Type == 1 ? 'active' : ''" @click="Type = 1">充值</div>
          <div class="type-item" :class="Type == 2 ? 'active' : ''" @click="Type = 2">购买商品</div>
          <div class="type-item" :class="Type == 3 ? 'active' : ''" @click="Type = 3">接口扣款</div>
          <div class="type-item" :class="Type == 4 ? 'active' : ''" @click="Type = 4">余额转佣金</div>
          <div class="type-item" :class="Type == 5 ? 'active' : ''" @click="Type = 5">佣金转余额</div>
          <div class="type-item" :class="Type == 6 ? 'active' : ''" @click="Type = 6">系统</div>
          <div class="type-item" :class="Type == 7 ? 'active' : ''" @click="Type = 7">退款</div>
          <div class="type-item" :class="Type == 8 ? 'active' : ''" @click="Type = 8">站长为下级创建分站</div>
          <div class="type-item" :class="Type == 20 ? 'active' : ''" @click="Type = 20">分站用户购买商品提成</div>
          <div class="type-item" :class="Type == 21 ? 'active' : ''" @click="Type = 21">分站用户购买分站收益</div>
          <div class="type-item" :class="Type == 22 ? 'active' : ''" @click="Type = 22">提现</div>
        </div>
        <div v-if="finish && dataList.length == 0" class="empty-item" style="padding: 50px 0;">
          <div class="icon img-cover"><img src="../../assets/pc-images/empty-icon.png" /></div>
        </div>
        <div v-else class="data-list-item">
          <div class="data-item" v-for="(item, index) in dataList" :key="index">
            <div class="header">
              <div class="content">{{ item.Content }} {{ item.Type == 20 && item.OrderNo ? '订单号：' + item.OrderNo : '' }}</div>
              <div class="money" :class="item.Money > 0 ? 'blue' : 'red'">
                {{ item.Money > 0 ? '+' : '' }}{{ item.Money }}
                <div class="is-rebates" v-if="item.Type == 20 && item.IsRebates == 0">冻结中</div>
              </div>
            </div>
            <div class="footer">
              <div class="time">{{ $TOOL.dateFormat(item.AddTime * 1000) }}</div>
              <div class="balance">余额: {{ item.Money | calcNewMoney(item.OldMoney) }}</div>
            </div>
          </div>
          <div v-if="!finish && dataList.length > 0" class="more-goods-btn" @click="handleGetIncomeLogList">
            <van-loading v-if="loading" size="20" color="#5783fc" />
            <span v-else>查看更多</span>
          </div>
        </div>
      </div>
    </pcUserNavComponent>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import pcTabBarComponent from '@/components/pcTabBarComponent'
import pcUserNavComponent from '@/components/pcUserNavComponent'

export default {
  name: "BalanceRecord",
  components: {
    pcTabBarComponent,
    pcUserNavComponent
  },
  data() {
    return {
      Type: 0,
      Page: 1,
      PageCount: 4,
      loading: false,
      finish: false,
      dataList: [],
      dataStatusObj: { '-1': '待付款', '1': '已付款', '2': '处理中', '3': '异常', '4': '已完成', '5': '退单中', '6': '已退单', '7': '已退款', '8': '待处理' },
    }
  },
  computed: {
    ...mapState(['userInfo', 'websiteInfo'])
  },
  filters: {
    calcNewMoney(money, oldMoney) {
      const now = parseFloat(oldMoney) + parseFloat(money)
      return Math.round(now * 100000) / 100000
    }
  },
  watch: {
    Type(val) {
      this.handleChangeType(val)
    }
  },
  mounted() {
    this.handleGetIncomeLogList()
  },
  methods: {
    handleChangeType(type) {
      this.Type = type
      this.Page = 1
      this.finish = false
      this.loading = false
      this.dataList = []
      this.handleGetIncomeLogList()
    },
    async handleGetIncomeLogList() {
      const { PageCount, Page, Type, dataList, loading, finish } = this
      if (loading || finish) {
        return
      }
      const params = {
        PageCount,
        Page
      }
      if (Type) {
        params.Type = Type
      }
      this.loading = true
      var res = await this.$API.incomeLogList.post(params)
      for (let index = 0; index < res.info.length; index++) {
        const item = res.info[index]
        res.info[index].Money = Math.round(item.Money * 100000) / 100000
      }
      this.dataList = [
        ...dataList,
        ...res.info
      ]
      this.Page = Page + 1
      this.finish = res.info.length < PageCount
      this.loading = false
    }
  },
}

</script>

<style lang="less" scoped>
.page-container {
  background-color: #fff;
  border-radius: 5px;
  padding: 0 15px;
  overflow: hidden;
}
.page-title-item {
  margin: 0 15px;
  padding-top: 10px;
  border-bottom: 1px solid #e5e5e5;
  .title-item {
    width: 112px;
    line-height: 48px;
    text-align: center;
    border-bottom: 2px solid transparent;
    color: #64748b;
    font-size: 18px;
    &.active {
      border-bottom-color: #5783fc;
      color: #5783fc;
    }
  }
}
.type-list-item {
  padding-top: 25px;
  overflow: hidden;
  .type-item {
    float: left;
    padding: 0 12px;
    height: 25px;
    border-radius: 13px;
    background-color: #f5f7fa;
    line-height: 25px;
    color: #64748b;
    font-size: 12px;
    margin-right: 10px;
    margin-bottom: 15px;
    cursor: pointer;
    &.active {
      background-color: #5783fc;
      color: #fff;
    }
  }
}
.data-list-item {
  .data-item {
    border-top: 1px solid #e5e5e5;
    padding: 14px;
    .header {
      display: flex;
      line-height: 20px;
      font-size: 14px;
      .content {
        flex: 1;
        color: #242941;
      }
      .money {
        margin-left: 20px;
        font-weight: bold;
        &.red {
          color: #ff2442;
        }
        &.blue {
          color: #276eff;
        }
        .is-rebates {
          text-align: right;
          color: #999;
          font-weight: normal;
          font-size: 10px;
          line-height: 14px;
        }
      }
    }
    .footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;
      line-height: 18px;
      font-size: 12px;
      .time {
        color: #ccc;
      }
      .balance {
        font-weight: bold;
        color: #242941;
      }
    }
  }
}
.more-goods-btn {
  margin: 20px auto 50px;
  width: 75px;
  height: 25px;
  border: 1px solid #5783fc;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #5783fc;
  font-weight: 500;
  cursor: pointer;
}
</style>